<template>
  <v-card style="border-radius: 10px;" class="pa-0 pt-2 ma-2">
    <v-list-item>
      <v-list-item-avatar>
        <v-avatar>
          <v-img contain :src="creator.photo || '/img/profile-default.jpg'" :alt="creator.name" />
        </v-avatar>
      </v-list-item-avatar>
      <p>{{creator.name}}</p>
    </v-list-item>
    <v-card-actions class="py-0 my-0">
      <v-btn @click="removeTapped" text small color="error">Remover</v-btn>
      <v-spacer />

      <v-btn @click="editDialog = true" text color="primary">
        Editar
        <v-icon>edit</v-icon>
      </v-btn>
    </v-card-actions>
    <edit-creator
      v-if="editDialog"
      v-model="editDialog"
      :creator="creator"
      :currentCreators="creators"
      :type="type"
    />
  </v-card>
</template>

<script>
import { removeCreatorFromContent } from "@/firebase/api/creator";
import EditCreator from "./Edit";
import CreatorMixin from "@/mixins/creatorData.js"

export default {
  components: { EditCreator },
  mixins: [CreatorMixin],
  props: { 
   creator: {
    type: Object,
    required: true,
   },
   creators: {
    type: Array,
    required: true,
   },
  },
  data: () => ({
    editDialog: false
  }),
  methods: {
    removeTapped() {
      removeCreatorFromContent(
        this.creator.id,
        this.$route.params.chapterID,
        this.$route.params.contentID,
        this.type,
      );
    },
  }
};
</script>